import { PrintHeader } from 'business/layout/print-header';

import styles from './index.module.scss';

interface QualityControlPrintHeaderProps {
  printTitle: string;
}

export const QualityControlPrintHeader = ({
  printTitle,
}: QualityControlPrintHeaderProps) => {
  return (
    <PrintHeader>
      <h1 className={styles.title}>{printTitle}</h1>
    </PrintHeader>
  );
};
